import React from 'react'

export default function Appify() {
  return (
    <section>
      <a className="anchor" id="appify"></a>
      <h2>App Icons</h2>
	  	<br/>
	  	<p>In the head section add the following tags</p>

	  	<pre><code className="language-html">{`<head>
  <!-- Other tags -->
  <link rel="green-3-touch-icon" sizes="180x180" href="/green-3-touch-icon.png">
  <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32">
  <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16">
  <link rel="manifest" href="/manifest.json">
  <meta name="theme-color" content="#000">
</head>`}</code></pre>

 			<br/>
 			<p>Place these assets in the root directory of your website.</p>

 			<table className="table table--rows table--notop">
	      <thead>
	        <tr>
	          <th>Filename</th>
	          <th>Image</th>
	        </tr>
	      </thead>
	      <tbody>
	      <tr>
	        <td><p className="push--top">android-chrome-512x512.png</p></td>
	        <td className="text--center soft"><img src="images/android-chrome-512x512.png" alt="Android icon 512px"/></td>
	      </tr>
	      <tr>
	        <td><p className="push--top">android-chrome-192x192.png</p></td>
	        <td className="text--center soft"><img src="images/android-chrome-192x192.png" alt="Android icon 192px"/></td>
	      </tr>
	      <tr>
	        <td><p className="push--top">green-3-touch-icon.png</p></td>
	        <td className="text--center soft"><img src="images/green-3-touch-icon.png" alt="green-3 icon icon 180px"/></td>
	      </tr>
	      <tr>
	        <td><p className="push--top">favicon.ico</p></td>
	        <td className="text--center soft"><img src="images/favicon.ico" alt="Favicon icon"/></td>
	      </tr>
	      <tr>
	        <td><p className="push--top">favicon-32x32.png</p></td>
	        <td className="text--center soft"><img src="images/favicon-32x32.png" alt="Favicon icon 32px"/></td>
	      </tr>
	      <tr>
	        <td><p className="push--top">favicon-16x16.png</p></td>
	        <td className="text--center soft"><img src="images/favicon-16x16.png" alt="Favicon icon 16px"/></td>
	      </tr>
	      </tbody>
	    </table>
	 			
 			<p>Create a <a href="https://w3c.github.io/manifest/">manifest.json</a> file at the root directory to add metadata about your application<br/>
 			An example would be -</p>

 			<pre><code className="language-html">{`{
	"name": "Common UI",
	"icons": [
		{
			"src": "\/android-chrome-192x192.png",
			"sizes": "192x192",
			"type": "image\/png"
		},
		{
			"src": "\/android-chrome-512x512.png",
			"sizes": "512x512",
			"type": "image\/png"
		}
	],
	"theme_color": "#000000",
	"display": "standalone"
}`}</code></pre>



      <hr/>
    </section>
  )
}


// WEBPACK FOOTER //
// ./styleguide/components/sections/Appify.js